import Asparagus from "./recipes/Asparagus";
import Baked_salmon_filets from "./recipes/Baked_salmon_filets";
import Baked_zucchini from "./recipes/Baked_zucchini";
import Banana_bread from "./recipes/Banana_bread";
import Boiled_eggs from "./recipes/Boiled_eggs";
import Brussel_sprouts from "./recipes/Brussel_sprouts";
import Carrot_cake from "./recipes/Carrot_cake";
import Chicken_liver_pate from "./recipes/Chicken_liver_pate";
import Chicken_liver_onion from "./recipes/Chicken_liver_onion";
import Corn_on_the_cob from "./recipes/Corn_on_the_cob";
import Eggs_sunny_side_up from "./recipes/Eggs_sunny_side_up";
import Fajitas from "./recipes/Fajitas";
import Garlic_sauce from "./recipes/Garlic_sauce";
import Greek_lamb_loaves from "./recipes/Greek_lamb_loaves";
import Greek_lemon_chicken from "./recipes/Greek_lemon_chicken";
import Greek_salad from "./recipes/Greek_salad";
import Greek_pita from "./recipes/Greek_pita";
import Guacamole from "./recipes/Guacamole";
import Horseradish_sauce from "./recipes/Horseradish_sauce";
import Leg_of_lamb from "./recipes/Leg_of_lamb";
import Pancetta_green_beans from "./recipes/Pancetta_green_beans";
import Parsnip_chips from "./recipes/Parsnip_chips";
import Parsnip_cream from "./recipes/Parsnip_cream";
import Pavlova from "./recipes/Pavlova";
import Pico_de_gallo from "./recipes/Pico_de_gallo";
import Pizza from "./recipes/Pizza";
import Pizza_sauce from "./recipes/Pizza_sauce";
import Potatoes_with_onions from "./recipes/Potatoes_with_onions";
import Red_lentil_soup from "./recipes/Red_lentil_soup";
import Roasted_cauliflower_soup from "./recipes/Roasted_cauliflower_soup";
import Shawarma from "./recipes/Shawarma";
import Shortbread from "./recipes/Shortbread";
import Soda_bread from "./recipes/Soda_bread";
import Tartare_sauce from "./recipes/Tartare_sauce";
import Tomato_chicken from "./recipes/Tomato_chicken";
import Turkey_escalopes_butter_lemon from "./recipes/Turkey_escalopes_butter_lemon";
import Varza_calita from "./recipes/Varza_calita";
import Yoghurt_sauce from "./recipes/Yoghurt_sauce";
import {
  Air_fryer_chicken_fried_rice,
  Air_fryer_chicken_thighs,
  Beet_salmon_salad,
  Boiled_baked_ribs,
  Bone_broth_oats,
  Cacio_e_pepe_chicken,
  Cauliflower_quiche,
  Crispy_roasted_cauliflower,
  Focaccia,
  French_carrot_salad,
  Fresh_tomato_soup,
  Fried_chicken,
  Fruit_nut_flapjacks,
  Hamburger_buns,
  Hamburger_patty,
  Hungarian_mushroom_soup,
  Japanese_cheesecake,
  Naan,
  Pancakes,
  Pilau_rice,
  Red_lentil_dahl,
  Roasted_carrot_soup,
  Seeded_bread,
  Tabbouleh,
  Tzatziki,
} from "./recipes/New_recipes_2026";
import type { Recipe } from "../types";

export const recipes: Record<string, Recipe> = {
  Asparagus: Asparagus,
  Air_fryer_chicken_fried_rice: Air_fryer_chicken_fried_rice,
  Air_fryer_chicken_thighs: Air_fryer_chicken_thighs,
  Baked_salmon_filets: Baked_salmon_filets,
  Baked_zucchini: Baked_zucchini,
  Banana_bread: Banana_bread,
  Beet_salmon_salad: Beet_salmon_salad,
  Boiled_eggs: Boiled_eggs,
  Boiled_baked_ribs: Boiled_baked_ribs,
  Bone_broth_oats: Bone_broth_oats,
  Brussel_sprouts: Brussel_sprouts,
  Cacio_e_pepe_chicken: Cacio_e_pepe_chicken,
  Carrot_cake: Carrot_cake,
  Cauliflower_quiche: Cauliflower_quiche,
  Chicken_liver_pate: Chicken_liver_pate,
  Chicken_liver_onion: Chicken_liver_onion,
  Corn_on_the_cob: Corn_on_the_cob,
  Crispy_roasted_cauliflower: Crispy_roasted_cauliflower,
  Eggs_sunny_side_up: Eggs_sunny_side_up,
  Fajitas: Fajitas,
  Focaccia: Focaccia,
  French_carrot_salad: French_carrot_salad,
  Fresh_tomato_soup: Fresh_tomato_soup,
  Fried_chicken: Fried_chicken,
  Fruit_nut_flapjacks: Fruit_nut_flapjacks,
  Garlic_sauce: Garlic_sauce,
  Greek_lamb_loaves: Greek_lamb_loaves,
  Greek_lemon_chicken: Greek_lemon_chicken,
  Greek_salad: Greek_salad,
  Greek_pita: Greek_pita,
  Guacamole: Guacamole,
  Hamburger_buns: Hamburger_buns,
  Hamburger_patty: Hamburger_patty,
  Horseradish_sauce: Horseradish_sauce,
  Hungarian_mushroom_soup: Hungarian_mushroom_soup,
  Japanese_cheesecake: Japanese_cheesecake,
  Leg_of_lamb: Leg_of_lamb,
  Naan: Naan,
  Pancetta_green_beans: Pancetta_green_beans,
  Pancakes: Pancakes,
  Parsnip_chips: Parsnip_chips,
  Parsnip_cream: Parsnip_cream,
  Pavlova: Pavlova,
  Pico_de_gallo: Pico_de_gallo,
  Pilau_rice: Pilau_rice,
  Pizza: Pizza,
  Pizza_sauce: Pizza_sauce,
  Potatoes_with_onions: Potatoes_with_onions,
  Red_lentil_dahl: Red_lentil_dahl,
  Red_lentil_soup: Red_lentil_soup,
  Roasted_carrot_soup: Roasted_carrot_soup,
  Roasted_cauliflower_soup: Roasted_cauliflower_soup,
  Seeded_bread: Seeded_bread,
  Shawarma: Shawarma,
  Shortbread: Shortbread,
  Soda_bread: Soda_bread,
  Tabbouleh: Tabbouleh,
  Tartare_sauce: Tartare_sauce,
  Tomato_chicken: Tomato_chicken,
  Turkey_escalopes_butter_lemon: Turkey_escalopes_butter_lemon,
  Tzatziki: Tzatziki,
  Varza_calita: Varza_calita,
  Yoghurt_sauce: Yoghurt_sauce,
};

export type RecipeId = string;

export const recipeList = Object.keys(recipes) as RecipeId[];
